import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useDeleteExchangeRateMutation} from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

const DeleteExchangeRateModal = ({showDeleteExchangeRateModal, onHide, details}) => {

    const [validated, setValidated] = useState(false);

    const [
        deleteExchangeRate, // This is the mutation trigger
        {
            isLoading: isDeleting,
            isSuccess: deletedSuccessfully,
        }, // This is the destructured mutation result
    ] = useDeleteExchangeRateMutation()

    /* Close Modal on Successful Deletion */
    useEffect(() => {
        if(deletedSuccessfully){
            cogoToast.success("Created 'Exchange Rate Deletion' Action Successfully")
            onHide();
        }
    }, [deletedSuccessfully]);

    /* Delete Exchange Rate */
    const onSubmit = e => {
        e.preventDefault();
        e.stopPropagation();

        deleteExchangeRate({id: details.id, meta: details});
    }

    return (
        <Modal
            show={showDeleteExchangeRateModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isDeleting ? "static" : true}
            keyboard={!isDeleting}
            onExited={_ => setValidated(false)}
        >
            <Form
                noValidate
                validated={validated}
                onSubmit={onSubmit}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Delete Exchange Rate
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                    <p>{`Are you sure you want to delete the exchange rate for ${details?.fromCurrency} to ${details?.toCurrency}?`}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        disabled={isDeleting}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isDeleting}
                        className="btn btn-danger btn-elevate px-4 ml-4"
                    >
                        Delete
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default DeleteExchangeRateModal;
